import { Pipe, PipeTransform } from '@angular/core';
import { truncate } from '@app/utilities/_index';

@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  /**
   * Transform a string to be truncated for a given length and trailing ellipsis (...)
   * @param value - string to be truncated
   * @param charLimt - character limit needed to determine truncated
   * @returns - a truncated string with trailing ...
   */
  transform(value: string, charLimit: number): string {
    return truncate(value, charLimit);
  }
}
